import { DefaultButton, MessageBar, MessageBarType, Panel, PanelType, PersonaCoin, PersonaSize, PrimaryButton, Stack, TextField, Toggle } from "office-ui-fabric-react";
import { useEffect, useState } from "react";
import { updateMyProfile } from "../../api/userInfo";
import { IUserWithPhoto } from "../../types/User.types";

export interface IProfileEditorPanelProps {
    profile: IUserWithPhoto; 
    onDismiss: () => void;
    onSaved: (profile: IUserWithPhoto) => void;
}

export const ProfileEditorPanel = (props: IProfileEditorPanelProps) => {
    const { profile } = props;

    const validForm = (fullName: string | undefined, org: string | undefined, phone: string | undefined, useTeams: boolean | undefined) => {
        if (!fullName || fullName.trim() === "") return false;
        if (!org || org.trim() === "") return false;
        if (!phone || phone.trim() === "") return false;
        if (useTeams === undefined) return false;
        return true;
    };

    const [ fullName, setFullName ] = useState<string|undefined>(profile.FullName);
    const [ organisation, setOrganisation ] = useState<string|undefined>(profile.Organisation);
    const [ phone, setPhone ] = useState<string|undefined>(profile.Phone);
    const [ useTeams, setTeams ] = useState<boolean|undefined>(profile.UseTeams);
    const [ error, setError ] = useState<string|undefined>();
    const [ formValid, setFormValid ] = useState<boolean>(validForm(fullName, organisation, phone, useTeams));
    
    useEffect(() => {
        setFormValid(validForm(fullName, organisation, phone, useTeams));
    }, [fullName, organisation, phone, useTeams]);

    const updateProfile = async (profile: IUserWithPhoto) => {
        const response = await updateMyProfile(profile);
        if (response.Success) {
            props.onSaved(profile);
            props.onDismiss();
        } else {
            setError(response.Error);
        }
    };

    return <Panel 
        isOpen={true} 
        onDismiss={props.onDismiss} 
        onRenderFooter={(panelProps) => {
            return <Stack horizontal horizontalAlign="end" style={{padding: 20}}>
                <PrimaryButton disabled={!formValid} iconProps={{iconName: "Save"}} text="Save" style={{marginRight: 20}} onClick={() => {
                    const profile = {...props.profile};
                    if (fullName) profile.FullName = fullName;
                    if (organisation) profile.Organisation = organisation;
                    if (phone) profile.Phone = phone;
                    if (useTeams !== undefined) profile.UseTeams = useTeams;
                    updateProfile(profile);
                }} />
                <DefaultButton iconProps={{iconName: "Cancel"}} text="Cancel" onClick={props.onDismiss} />
            </Stack>
        }}
        headerText="Edit Desk Booking Profile"
        type={PanelType.medium} 
    >
        { error !== undefined && (
            <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>
        )}
        <PersonaCoin 
            size={PersonaSize.size100}
            imageUrl={profile.Photo !== null ? `data:${profile.Photo.Type};base64,${profile.Photo.Data}` : undefined} 
            text={profile.FullName}
            style={{margin: "20px 0px"}}
        />
        <TextField title="Full Name" label="Full Name" value={fullName} onChange={(e, newValue) => setFullName(newValue)}></TextField>
        <TextField title="Organisation" label="Organisation" value={organisation} onChange={(e, newValue) => setOrganisation(newValue)}></TextField>
        <TextField title="Phone Number" label="Phone Number" value={phone} onChange={(e, newValue) => setPhone(newValue)}></TextField>
        <img
            src="https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/svg/teams_48x1.svg"
            width="48"
            height="48"
            alt="Teams product icon"
            style={{marginTop: 20}}
        />
        <Toggle label="Microsoft Teams" checked={useTeams} onChange={(e, checked) => setTeams(checked)} onText="I can be contacted on Microsoft Teams" offText="I cannot be contacted on Microsoft Teams" />
    </Panel>
}
